/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/lightningstrike'
export default icon
